import { useEffect, useState } from "react";

const State = ({value, state=null, name, duration=400 })=>{


    const [animationClass, setAnimationClass] = useState('');
    const [currentNumber, setCurrentNumber] = useState(0);


    useEffect(() => {
        let start = 0;
        const increment = value / (duration / 100); // Durée divisée pour faire l'animation fluide
        const interval = setInterval(() => {
            start += increment;
            if (start >= value) {
                setCurrentNumber(value);
                clearInterval(interval);
            } else {
                setCurrentNumber(Math.floor(start));
            }
        }, 100);

        return () => clearInterval(interval); // Nettoyage lors du démontage du composant
    }, [value, duration]);


    return (

        <>
        {state === 'res' &&    <div className="relative p-6 bg-green-600 shadow rounded-2xl animate-pulse">
                <div class="space-y-2">
                    <div
                        class="flex items-center space-x-2 rtl:space-x-reverse text-sm font-medium text-gray-600 dark:text-gray-100">
                        <span>{name}</span>
                    </div>

                    <div class="text-3xl dark:text-gray-100">                        
                        {currentNumber}
                    </div>
                </div>
            </div>}

            {state === 'inWainting' &&    <div className="relative p-6 bg-indigo-800 shadow rounded-2xl animate-pulse">
                <div class="space-y-2">
                    <div
                        class="flex items-center space-x-2 rtl:space-x-reverse text-sm font-medium text-gray-600 dark:text-gray-100">
                        <span>{name}</span>
                    </div>

                    <div class="text-3xl dark:text-gray-100">
                        {currentNumber}
                    </div>
                </div>
            </div>}


            {state === 'echec' &&    <div className="relative p-6 bg-red-600 shadow rounded-2xl animate-pulse">
                <div class="space-y-2">
                    <div
                        class="flex items-center space-x-2 rtl:space-x-reverse text-sm font-medium text-gray-600 dark:text-gray-100">
                        <span>{name}</span>
                    </div>

                    <div class="text-3xl dark:text-gray-100">
                        {currentNumber}
                    </div>
                </div>
            </div>}

            {state === 'ended' &&    <div className="relative p-6 shadow rounded-2xl dark:bg-gray-800">
                <div class="space-y-2">
                    <div
                        class="flex items-center space-x-2 rtl:space-x-reverse text-sm font-medium text-gray-600 dark:text-gray-100">
                        <span>{name}</span>
                    </div>

                    <div class="text-3xl dark:text-gray-100">
                        {currentNumber}
                    </div>
                </div>
            </div>}


            {state === null &&    <div className="relative p-6 shadow w-30 rounded-2xl dark:bg-indigo-800">
                <div class="space-y-2">
                    <div
                        class="flex items-center space-x-2 rtl:space-x-reverse text-sm font-medium text-gray-600 dark:text-gray-100">
                        <span>{name}</span>
                    </div>

                    <div class="text-3xl dark:text-gray-100">
                        {currentNumber}
                    </div>
                </div>
            </div>}
        </>
    )
}

export default State;